require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tmoignages-dalumni-2-0-7.json") })
        }
      }, "path---tmoignages-dalumni-2-0-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tmoignages-dalumni-2-0-7!./.cache/json/tmoignages-dalumni-2-0-7.json
// module id = 587
// module chunks = 231608221292675